type ArbitraryDimMatrix = Array<ArbitraryDimMatrix> | number;
type NdimMatrix<
	N extends number,
	Acc extends ArbitraryDimMatrix = number,
	Counter extends never[] = []
> = Counter['length'] extends N ? Acc : NdimMatrix<N, Array<Acc>, [never, ...Counter]>;
export type Matrix<N extends number = number> = number extends N ? ArbitraryDimMatrix : NdimMatrix<N>;
